import React, {Component} from 'react';
import styles from './loginModal.module.css';
import LoginForm from '../loginForm/loginForm';
import {Backdrop} from '@material-ui/core';
import {connect} from 'react-redux';
import {
    tryAuthWithEmail,
    tryCreateAccount,
    hideLoginModal,
} from '../../store/index';

class LoginModal extends Component {
    state = {
        errorMessage: '',
        email: '',
        password: '',
        passwordRepeat: '',
        register: false,
    };

    onEmailChangeHandler = event => {
        this.setState({email: event.target.value});
    };

    onPasswordChangeHandler = event => {
        this.setState({password: event.target.value});
    };

    onPasswordRepeatChangeHandler = event => {
        this.setState({passwordRepeat: event.target.value});
    };

    onRegisterButtonClickHandler = () =>
        this.setState(prevState => ({
            register: !prevState.register,
        }));

    onLoginButtonClickHandler = () => {
        this.setState({loading: true});
        const {email, password, passwordRepeat, register} = this.state;
        const {tryAuthWithEmail, tryCreateAccount} = this.props;
        if (password.trim() === passwordRepeat.trim() || !register) {
            const authData = {
                email: email.trim(),
                password: password.trim(),
            };
            register
                ? tryCreateAccount(
                      authData,
                      this.onLoginSuccessHandler,
                      this.onLoginFailHandler,
                  )
                : tryAuthWithEmail(
                      authData,
                      this.onLoginSuccessHandler,
                      this.onLoginFailHandler,
                  );
        } else {
            this.onLoginFailHandler('Hasła nie zgadzają się ze sobą');
        }
    };

    onLoginFailHandler = errorMessage =>
        this.setState({errorMessage, loading: false});

    onLoginSuccessHandler = () => {
        this.props.hideLoginModal();
        this.setState({loading: false});
    };

    render() {
        const {hideLoginModal} = this.props;
        const {register} = this.state;
        return (
            <div className={styles.loginModal}>
                <Backdrop open={true} onClick={hideLoginModal} />
                <LoginForm
                    onEmailChange={this.onEmailChangeHandler}
                    onPasswordChange={this.onPasswordChangeHandler}
                    onLoginButtonClick={this.onLoginButtonClickHandler}
                    onRegisterButtonClick={this.onRegisterButtonClickHandler}
                    onPasswordRepeatChange={this.onPasswordRepeatChangeHandler}
                    alert={this.state.errorMessage}
                    register={register}
                />
            </div>
        );
    }
}

const mapDispatchToProps = {
    hideLoginModal,
    tryAuthWithEmail,
    tryCreateAccount,
};

export default connect(null, mapDispatchToProps)(LoginModal);
